export default "__VITE_ASSET__ClGyQ0AA__"